import { Search, X } from "lucide-react";
import { F, T } from "../../theme/tokens";

// ── Search + filter bar ───────────────────────────────────────────────────────

export function SearchBar({ value, onChange, placeholder }: { value: string; onChange: (v: string) => void; placeholder?: string }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "9px", background: T.s2, border: `1px solid ${T.border}`, borderRadius: "8px", padding: "8px 12px", flex: 1, maxWidth: "320px" }}>
      <Search size={14} style={{ color: T.muted, flexShrink: 0 }} />
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder ?? "Search…"} style={{ border: "none", outline: "none", background: "transparent", fontSize: "12px", fontFamily: F, color: T.text, width: "100%" }} />
      {value && <button onClick={() => onChange("")} style={{ background: "none", border: "none", cursor: "pointer", color: T.muted, lineHeight: 0 }}><X size={12} /></button>}
    </div>
  );
}
